import React, { useEffect, useState } from "react";
import Row from 'react-bootstrap/Row'
import {
    Container,
    Typography,
    TextField,
    Grid,
    Box,
    FormControl,
    MenuItem,
    Checkbox,
    FormGroup,
    FormControlLabel,
    Button,
    IconButton,
    CircularProgress,
    makeStyles,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { IoMdArrowBack } from 'react-icons/io'
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import Palette from "../../Palette";
import MomentUtils from '@date-io/moment';
import Upload from "../../models/Upload";
import moment from "moment";
import Member from "../../models/Member";
import Swal from "sweetalert2";
import Alert from "../../components/Alert";
import { useHistory } from "react-router-dom";
import AsyncSelect from 'react-select/async'

const useStyles = makeStyles({
    noBorderInput: {
        '& .MuiOutlinedInput-root': {
            backgroundColor: '#e9f3f4',
            '& fieldset': {
                border: 'none !important',
            },
            '&:hover fieldset': {
                border: 'none !important',
            },
            '&.Mui-focused fieldset': {
                border: 'none !important',
            },
        },
        '& .MuiOutlinedInput-notchedOutline': {
            border: 'none !important',
        },
        '& fieldset': {
            border: 'none !important',
        },
    },
});

export default function MitraAccountProfileForm({ props }) {
    const modelUpload = new Upload()
    const modelMember = new Member()
    const history = useHistory()
    const classes = useStyles();
    const [errorMsg, setErrorMsg] = useState(null);
    const [errors, setErrors] = useState({});

    const [mitraYearFounded, setMitraYearFounded] = useState(null); //Tahun Berdiri
    const [mitraServices, setMitraServices] = useState({ //Bidang Layanan Bahasa Utama
        penerjemahan: false,
        interpreting: false,
        pelatihan: false,
        penyusunan: false,
        lainnya: false,
    });
    const [aboutMe, setAboutMe] = useState(null); //Tentang Mitra Swasta
    const [mitraVision, setMitraVision] = useState(null); //Visi
    const [mitraMission, setMitraMission] = useState(null); //Misi

    const [mitraPortfolio, setMitraPortfolio] = useState([]); //Portofolio layanan utama/klien (file upload)
    const [mitraPortfolioUploading, setMitraPortfolioUploading] = useState(false); //Upload progress state
    const [mitraResourceTranslator, setMitraResourceTranslator] = useState(null); //Jumlah tenaga penerjemah
    const [mitraResourceIntrepater, setMitraResourcIntrepater] = useState(null);//Jumlah tenaga juru bahasa
    const [mitraResourceHasReferance, setMitraResourceHasReferance] = useState(false);// //Apakah ada penerjemah/juru bahasa Anggota HPI di dalam tim?
    const [mitraResourceReference, setMitraResourceReference] = useState([]); //when mitraResourceHasReferance true, this field is required
    const [mitraAttachmentDocument, setMitraAttachmentDocument] = useState({
        salinan_akta: [],
        salinan_nib_siup_tpd: [],
        profile: [],
        profession: [],
    }); //mitra_attachment_document
    const [mitraAttachmentChecked, setMitraAttachmentChecked] = useState({
        salinan_akta: false,
        salinan_nib_siup_tpd: false,
        profile: false,
        profession: false,
    });
    const [mitraAttachmentUploading, setMitraAttachmentUploading] = useState({
        salinan_akta: false,
        salinan_nib_siup_tpd: false,
        profile: false,
        profession: false,
    });

    const [members, setMembers] = useState([])

    const handleServiceChange = (e) => {
        setMitraServices({ ...mitraServices, [e.target.name]: e.target.checked });
    };

    const handleAttachmentUpload = async (fieldName, files) => {
        setMitraAttachmentUploading({ ...mitraAttachmentUploading, [fieldName]: true });
        try {
            const uploadedFiles = [];
            for (let file of files) {
                const formData = new FormData();
                formData.append('upload', file, file.name);
                const result = await modelUpload.uploadImage(formData);
                if (result?.location) {
                    uploadedFiles.push({
                        name: file.name,
                        url: result.location
                    });
                }
            }
            setMitraAttachmentDocument({
                ...mitraAttachmentDocument,
                [fieldName]: [...mitraAttachmentDocument[fieldName], ...uploadedFiles]
            });
            if (errors.mitraAttachmentDocument) {
                setErrors({ ...errors, mitraAttachmentDocument: null });
            }
        } catch (e) {
            console.error(e);
        } finally {
            setMitraAttachmentUploading({ ...mitraAttachmentUploading, [fieldName]: false });
        }
    };

    const handleAttachmentRemove = (fieldName, index) => {
        const newFiles = mitraAttachmentDocument[fieldName].filter((_, i) => i !== index);
        setMitraAttachmentDocument({
            ...mitraAttachmentDocument,
            [fieldName]: newFiles
        });
    };

    const getMembers = async () => {
        try {
            let result = await modelMember.getAllActiveClean()
            let filtered = result
                .map((el) => {
                    return {
                        value: el.id,
                        full_name: el.full_name,
                        hpi_id: el.hpi_id,
                        label: `${el.hpi_id} | ${el.full_name}`,
                    }
                })
            setMembers(filtered)
        } catch (e) {}
    }
    
    const filterMembers = (inputValue) => {
        return members.filter((i) => i.label.toLowerCase().includes(inputValue.toLowerCase()))
    }

    const loadOptions = (inputValue, callback) => {
        setTimeout(() => {
            callback(filterMembers(inputValue))
        }, 1000)
    }

    const validateForm = () => {
        const newErrors = {};

        const checkedDocument = Object.values(mitraAttachmentChecked).some(
            (checked) => checked === true
        );
        if (!checkedDocument) {
            newErrors.mitraAttachmentDocument = 'Minimal satu dokumen harus dipilih';
        }
        const hasDocument = Object.values(mitraAttachmentDocument).some(
            (docArray) => docArray && docArray.length > 0
        );
        if (!hasDocument) {
            newErrors.mitraAttachmentDocument = 'Minimal satu dokumen harus diunggah';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        try {
            setErrors({});
            setErrorMsg(null);

            if (!validateForm()) {
                setErrorMsg('Mohon lengkapi semua kolom yang wajib diisi');
                window.scrollTo({ top: 0, behavior: 'smooth' });
                return;
            }

            const confirmResult = await Swal.fire({
                title: 'Konfirmasi',
                text: 'Apakah Anda yakin ingin menyimpan perubahan data profil?',
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#0000FF',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ya, Simpan',
                cancelButtonText: 'Batal',
            });

            if (!confirmResult.isConfirmed) {
                return;
            }

            const payload = {
                mitra_year_founded: mitraYearFounded ? moment(mitraYearFounded).year() : null,
                mitra_services: mitraServices,
                about_me: aboutMe,
                mitra_vision: mitraVision,
                mitra_mission: mitraMission,
                mitra_attachment_portofolio: mitraPortfolio,
                mitra_resource_translator: mitraResourceTranslator,
                mitra_resource_intrepater: mitraResourceIntrepater,
                mitra_resource_has_referance: mitraResourceHasReferance,
                mitra_resource_reference: mitraResourceReference,
                mitra_attachment_document: mitraAttachmentDocument,
            }
            await modelMember.editMemberData(payload)

            Swal.fire({
                icon: 'success',
                title: 'Berhasil',
                text: 'Data profil berhasil disimpan',
                confirmButtonText: 'OK',
                confirmButtonColor: '#0000FF',
            }).then(() => {
                history.push('/member/akun');
            })

        } catch (e) {
            Swal.fire({
                icon: 'error',
                title: 'Terjadi Kesalahan',
                text: e?.error_message || e?.message || 'Gagal mengirim data. Silakan coba lagi.',
            })
            console.error(e)
        } finally {

        }
    }


    const fetchSelfData = async () => {
        try {
            let result = await modelMember.getMemberData()
            const memberData = result?.member

            if (memberData) {
                // Set Tahun Berdiri
                if (memberData.mitra_year_founded) {
                    setMitraYearFounded(moment().year(memberData.mitra_year_founded));
                }

                // Set Bidang Layanan
                if (memberData.mitra_services) {
                    setMitraServices(memberData.mitra_services);
                }

                // Set About Me
                setAboutMe(memberData.about_me);

                // Set Visi & Misi
                setMitraVision(memberData.mitra_vision);
                setMitraMission(memberData.mitra_mission);

                // Set Portfolio
                if (memberData.mitra_attachment_portofolio) {
                    setMitraPortfolio(memberData.mitra_attachment_portofolio);
                }

                // Set Sumber Daya Manusia
                setMitraResourceTranslator(memberData.mitra_resource_translator);
                setMitraResourcIntrepater(memberData.mitra_resource_intrepater);
                setMitraResourceHasReferance(memberData.mitra_resource_has_referance === 1);

                if (memberData.mitra_resource_reference) {
                    setMitraResourceReference(memberData.mitra_resource_reference);
                }

                if (memberData.mitra_attachment_document) {
                    const docs = memberData.mitra_attachment_document;
                    setMitraAttachmentDocument({
                        salinan_akta: docs.salinan_akta || [],
                        salinan_nib_siup_tpd: docs.salinan_nib_siup_tpd || [],
                        profile: docs.profile || [],
                        profession: docs.profession || [],
                    });

                    setMitraAttachmentChecked({
                        salinan_akta: (docs.salinan_akta || []).length > 0,
                        salinan_nib_siup_tpd: (docs.salinan_nib_siup_tpd || []).length > 0,
                        profile: (docs.profile || []).length > 0,
                        profession: (docs.profession || []).length > 0,
                    });
                }
            }
        } catch (e) {
            console.log('ERROR' + e)
        }
    }

    const handleBackButton = () => {
        history.push('/member/akun');
    }

    useEffect(() => {
        const userStorage = localStorage.getItem('user');
        if (!userStorage) {
            history.replace('/');
            return;
        }

        try {
            const user = JSON.parse(userStorage);
            if (user.role !== 'MITRA_SWASTA') {
                history.replace('/');
                return;
            }
        } catch (e) {
            console.error('Error parsing user data:', e);
            history.replace('/');
            return;
        }

        fetchSelfData()
        getMembers()
    }, [history])

    return (
        <>
            <Container maxWidth="lg" sx={{ px: 5, py: 5, fontFamily: 'Signika, sans-serif' }} >

                {
                    errorMsg && <Alert
                        type="error"
                        className="mx-0"
                        errorMsg={errorMsg}
                        textStyle={{ fontSize: 16, fontWeight: 500 }}
                    />
                }

                {/* Profil Usaha */}
                <Box sx={{
                    backgroundColor: '#fff',
                    borderRadius: 2,
                    p: 4,
                    mb: 4,
                    boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
                }}>
                    <Row>
                        <div
                            onClick={handleBackButton}
                            style={{
                                backgroundColor: 'white',
                                borderColor: 'white',
                                color: 'black',
                                cursor: 'pointer',
                            }}
                            className="p-3"
                        >
                            <IoMdArrowBack size={20} />
                        </div>
                        <div
                            style={{
                                fontFamily: 'Signika',
                                fontWeight: '800',
                                fontSize: '1.75em',
                                color: Palette.PRIMARY,
                            }}
                            className="text-center w-100"
                        >
                            Ubah Profil
                        </div>
                    </Row>

                    <Grid container spacing={3}>
                        {/* Tahun Berdiri */}
                        <Grid item xs={12}>
                            <FormControl fullWidth>

                                <div
                                    style={{
                                        fontFamily: 'Signika',
                                        fontWeight: '600',
                                        fontSize: '0.75em',
                                        color: '#8e8e8e',
                                        marginBottom: 7,
                                    }}
                                    className="mt-3 text-uppercase"
                                >
                                    Tahun Berdiri
                                </div>

                                <MuiPickersUtilsProvider utils={MomentUtils}>
                                    <DatePicker
                                        views={["year"]}
                                        value={mitraYearFounded}
                                        onChange={(date) => setMitraYearFounded(date)}
                                        inputVariant="outlined"
                                        fullWidth
                                        maxDate={moment()}
                                        TextFieldComponent={(props) => (
                                            <TextField
                                                {...props}
                                                className={classes.noBorderInput}
                                                InputProps={{
                                                    ...props.InputProps,
                                                    style: {
                                                        fontFamily: 'Signika, sans-serif',
                                                    }
                                                }}
                                            />
                                        )}
                                    />
                                </MuiPickersUtilsProvider>
                            </FormControl>
                        </Grid>

                        {/* Bidang Layanan Bahasa Utama */}
                        <Grid item xs={12}>
                            <div
                                style={{
                                    fontFamily: 'Signika',
                                    fontWeight: '600',
                                    fontSize: '0.75em',
                                    color: '#8e8e8e',
                                    marginBottom: 7,
                                }}
                                className="mt-3 text-uppercase"
                            >
                                Bidang Layanan Bahasa Utama
                            </div>
                            <FormGroup>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={mitraServices.penerjemahan}
                                            onChange={handleServiceChange}
                                            name="penerjemahan"
                                            color="primary"
                                        />
                                    }
                                    label="Penerjemahan Tulis"
                                    sx={{ '& .MuiFormControlLabel-label': { fontFamily: 'Signika, sans-serif' } }}
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={mitraServices.interpreting}
                                            onChange={handleServiceChange}
                                            name="interpreting"
                                            color="primary"
                                        />
                                    }
                                    label="Penjurubahasaan (Interpreting)"
                                    sx={{ '& .MuiFormControlLabel-label': { fontFamily: 'Signika, sans-serif' } }}
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={mitraServices.pelatihan}
                                            onChange={handleServiceChange}
                                            name="pelatihan"
                                            color="primary"
                                        />
                                    }
                                    label="Pelatihan Bahasa"
                                    sx={{ '& .MuiFormControlLabel-label': { fontFamily: 'Signika, sans-serif' } }}
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={mitraServices.penyusunan}
                                            onChange={handleServiceChange}
                                            name="penyusunan"
                                            color="primary"
                                        />
                                    }
                                    label="Penyusunan / Penyuntingan Dokumen"
                                    sx={{ '& .MuiFormControlLabel-label': { fontFamily: 'Signika, sans-serif' } }}
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={mitraServices.lainnya}
                                            onChange={handleServiceChange}
                                            name="lainnya"
                                            color="primary"
                                        />
                                    }
                                    label="Layanan Bahasa Lainnya"
                                    sx={{ '& .MuiFormControlLabel-label': { fontFamily: 'Signika, sans-serif' } }}
                                />
                            </FormGroup>
                        </Grid>

                        {/* tentang Visi & Misi */}

                        <Grid item xs={12} md={12}>
                            <FormControl fullWidth>
                                <div
                                    style={{
                                        fontFamily: 'Signika',
                                        fontWeight: '600',
                                        fontSize: '0.75em',
                                        color: '#8e8e8e',
                                        marginBottom: 7,
                                    }}
                                    className="mt-3 text-uppercase"
                                >
                                    Tentang Mitra Swasta Terdaftar
                                </div>
                                <TextField
                                    fullWidth
                                    multiline
                                    rows={6}
                                    placeholder="Masukkan deskripsi tentang Mitra Swasta Terdaftar"
                                    variant="outlined"
                                    value={aboutMe || ''}
                                    onChange={(e) => setAboutMe(e.target.value)}
                                    className={classes.noBorderInput}
                                    InputProps={{
                                        style: {
                                            fontFamily: 'Signika, sans-serif',
                                        }
                                    }}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <FormControl fullWidth>
                                <div
                                    style={{
                                        fontFamily: 'Signika',
                                        fontWeight: '600',
                                        fontSize: '0.75em',
                                        color: '#8e8e8e',
                                        marginBottom: 7,
                                    }}
                                    className="mt-3 text-uppercase"
                                >
                                    Visi
                                </div>
                                <TextField
                                    fullWidth
                                    multiline
                                    rows={3}
                                    placeholder="Input Visi"
                                    variant="outlined"
                                    value={mitraVision || ''}
                                    onChange={(e) => setMitraVision(e.target.value)}
                                    className={classes.noBorderInput}
                                    InputProps={{
                                        style: {
                                            fontFamily: 'Signika, sans-serif',
                                        }
                                    }}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <FormControl fullWidth>
                                <div
                                    style={{
                                        fontFamily: 'Signika',
                                        fontWeight: '600',
                                        fontSize: '0.75em',
                                        color: '#8e8e8e',
                                        marginBottom: 7,
                                    }}
                                    className="mt-3 text-uppercase"
                                >
                                    Misi
                                </div>
                                <TextField
                                    fullWidth
                                    multiline
                                    rows={3}
                                    placeholder="Input Misi"
                                    variant="outlined"
                                    value={mitraMission || ''}
                                    onChange={(e) => setMitraMission(e.target.value)}
                                    className={classes.noBorderInput}
                                    InputProps={{
                                        style: {
                                            fontFamily: 'Signika, sans-serif',
                                        }
                                    }}
                                />
                            </FormControl>
                        </Grid>

                        {/* Portofolio */}
                        <Grid item xs={12}>
                            <FormControl fullWidth>
                                <div
                                    style={{
                                        fontFamily: 'Signika',
                                        fontWeight: '600',
                                        fontSize: '0.75em',
                                        color: '#8e8e8e',
                                        marginBottom: 7,
                                    }}
                                    className="mt-3 text-uppercase"
                                >
                                    Portofolio layanan utama/klien{" "}
                                    <span style={{ fontStyle: "italic", textTransform: 'none' }}>
                                        (opsional)
                                    </span>
                                </div>
                                <Box>
                                    <input
                                        id="upload-portfolio"
                                        type="file"
                                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                                        multiple
                                        style={{ display: 'none' }}
                                        onChange={async (e) => {
                                            if (e.target.files.length > 0) {
                                                setMitraPortfolioUploading(true);
                                                try {
                                                    const uploadedFiles = [];
                                                    for (let file of Array.from(e.target.files)) {
                                                        const formData = new FormData();
                                                        formData.append('upload', file, file.name);
                                                        const result = await modelUpload.uploadImage(formData);
                                                        if (result?.location) {
                                                            uploadedFiles.push({
                                                                name: file.name,
                                                                url: result.location
                                                            });
                                                        }
                                                    }
                                                    setMitraPortfolio([...(mitraPortfolio || []), ...uploadedFiles]);
                                                } catch (e) {
                                                    console.error(e);
                                                } finally {
                                                    setMitraPortfolioUploading(false);
                                                }
                                            }
                                        }}
                                    />
                                    <Button
                                        variant="outlined"
                                        onClick={() => document.getElementById('upload-portfolio').click()}
                                        disabled={mitraPortfolioUploading}
                                        sx={{ fontFamily: 'Signika, sans-serif' }}
                                        startIcon={mitraPortfolioUploading ? <CircularProgress size={20} /> : null}
                                    >
                                        {mitraPortfolioUploading ? 'Mengunggah...' : 'Unggah File'}
                                    </Button>
                                    {mitraPortfolio && mitraPortfolio.length > 0 && (
                                        <Box mt={1}>
                                            {mitraPortfolio.map((file, index) => (
                                                <Box key={index} display="flex" alignItems="center" gap={1} mb={1}>
                                                    <Typography variant="body2" sx={{ fontFamily: 'Signika, sans-serif' }}>{file.name}</Typography>
                                                    <IconButton
                                                        size="small"
                                                        onClick={() => {
                                                            const newFiles = mitraPortfolio.filter((_, i) => i !== index);
                                                            setMitraPortfolio(newFiles);
                                                        }}
                                                    >
                                                        <CloseIcon fontSize="small" />
                                                    </IconButton>
                                                </Box>
                                            ))}
                                        </Box>
                                    )}
                                </Box>
                            </FormControl>
                        </Grid>
                    </Grid>
                </Box>

                {/* Sumber Daya Manusia */}
                <Box sx={{
                    backgroundColor: '#fff',
                    borderRadius: 2,
                    p: 4,
                    mb: 4,
                    boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
                }}>
                    <Box mb={3}>
                        <Typography variant="h6" fontWeight="bold" sx={{ fontFamily: 'Signika, sans-serif' }}>
                            Sumber Daya Manusia
                        </Typography>
                    </Box>

                    <Grid container spacing={3}>
                        {/* 1. Jumlah tenaga penerjemah */}
                        <Grid item xs={12}>
                            <div
                                style={{
                                    fontFamily: 'Signika',
                                    fontWeight: '600',
                                    fontSize: '0.75em',
                                    color: '#8e8e8e',
                                    marginBottom: 7,
                                }}
                                className="mt-3 text-uppercase"
                            >
                                Jumlah tenaga penerjemah
                            </div>
                            <Box display="flex" alignItems="center">
                                <TextField
                                    type="number"
                                    size="small"
                                    sx={{ width: 120, mr: 2 }}
                                    placeholder=""
                                    value={mitraResourceTranslator || ''}
                                    onChange={(e) => setMitraResourceTranslator(e.target.value)}
                                    InputProps={{
                                        sx: {
                                            fontFamily: 'Signika, sans-serif',
                                            backgroundColor: '#e9f3f4'
                                        }
                                    }}
                                />
                                <Typography sx={{ fontFamily: 'Signika, sans-serif' }}>Orang</Typography>
                            </Box>
                        </Grid>

                        {/* 2. Jumlah tenaga juru bahasa */}
                        <Grid item xs={12}>
                            <div
                                style={{
                                    fontFamily: 'Signika',
                                    fontWeight: '600',
                                    fontSize: '0.75em',
                                    color: '#8e8e8e',
                                    marginBottom: 7,
                                }}
                                className="mt-3 text-uppercase"
                            >
                                Jumlah tenaga juru bahasa
                            </div>
                            <Box display="flex" alignItems="center">
                                <TextField
                                    type="number"
                                    size="small"
                                    sx={{ width: 120, mr: 2 }}
                                    placeholder=""
                                    value={mitraResourceIntrepater || ''}
                                    onChange={(e) => setMitraResourcIntrepater(e.target.value)}
                                    InputProps={{
                                        sx: {
                                            fontFamily: 'Signika, sans-serif',
                                            backgroundColor: '#e9f3f4'
                                        }
                                    }}
                                />
                                <Typography sx={{ fontFamily: 'Signika, sans-serif' }}>Orang</Typography>
                            </Box>
                        </Grid>

                        {/* 3. Ada anggota HPI? */}
                        <Grid item xs={12}>
                            <div
                                style={{
                                    fontFamily: 'Signika',
                                    fontWeight: '600',
                                    fontSize: '0.75em',
                                    color: '#8e8e8e',
                                    marginBottom: 7,
                                }}
                                className="mt-3 text-uppercase"
                            >
                                Apakah ada penerjemah/juru bahasa Anggota HPI di dalam tim?
                            </div>
                            <FormGroup>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={mitraResourceHasReferance}
                                            onChange={(e) => setMitraResourceHasReferance(e.target.checked)}
                                            name="ya"
                                            color="primary"
                                        />
                                    }
                                    label="Ya (sebutkan nama dan nomor anggota HPI)"
                                    sx={{ '& .MuiFormControlLabel-label': { fontFamily: 'Signika, sans-serif' } }}
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={!mitraResourceHasReferance}
                                            onChange={(e) => setMitraResourceHasReferance(!e.target.checked)}
                                            name="tidak"
                                            color="primary"
                                        />
                                    }
                                    label="Tidak"
                                    sx={{ '& .MuiFormControlLabel-label': { fontFamily: 'Signika, sans-serif' } }}
                                />
                            </FormGroup>

                            <AsyncSelect
                                placeholder={'+ Tambah Anggota HPI'}
                                onChange={(e) => setMitraResourceReference([...mitraResourceReference, { full_name: e.full_name, hpi_id: e.hpi_id }])}
                                cacheOptions
                                defaultOptions
                                loadOptions={loadOptions}
                                value={null}
                            />
                            {mitraResourceHasReferance && (
                                <Box mt={2}>
                                    {mitraResourceReference.map((ref, index) => (
                                        <Box style={{ display: 'flex', gap: 10 }} key={index} mb={2} alignItems="center">
                                            <TextField
                                                fullWidth
                                                placeholder="Nama Anggota HPI"
                                                variant="outlined"
                                                size="small"
                                                value={ref.full_name || ''}
                                                onChange={(e) => {
                                                    const newRefs = [...mitraResourceReference];
                                                    newRefs[index].full_name = e.target.value;
                                                    setMitraResourceReference(newRefs);
                                                }}
                                                className={classes.noBorderInput}
                                                InputProps={{
                                                    style: {
                                                        fontFamily: 'Signika, sans-serif',
                                                    }
                                                }}
                                            />
                                            <TextField
                                                fullWidth
                                                placeholder="Nomor Anggota HPI"
                                                variant="outlined"
                                                size="small"
                                                value={ref.hpi_id || ''}
                                                onChange={(e) => {
                                                    const newRefs = [...mitraResourceReference];
                                                    newRefs[index].hpi_id = e.target.value;
                                                    setMitraResourceReference(newRefs);
                                                }}
                                                className={classes.noBorderInput}
                                                InputProps={{
                                                    style: {
                                                        fontFamily: 'Signika, sans-serif',
                                                    }
                                                }}
                                            />
                                            <IconButton
                                                color="secondary"
                                                onClick={() => {
                                                    const newRefs = mitraResourceReference.filter((_, i) => i !== index);
                                                    setMitraResourceReference(newRefs);
                                                }}
                                            >
                                                <CloseIcon />
                                            </IconButton>
                                        </Box>
                                    ))}
                                    {/* <Button
                                        variant="outlined"
                                        color="primary"
                                        onClick={() => {
                                            setMitraResourceReference([...mitraResourceReference, { full_name: '', hpi_id: '' }]);
                                        }}
                                        sx={{ fontFamily: 'Signika, sans-serif' }}
                                    >
                                        + Tambah Anggota HPI
                                    </Button> */}
                                </Box>
                            )}
                        </Grid>
                    </Grid>
                </Box>

                {/* Dokumen yang Dilampirkan */}
                {/* <Box sx={{
                    backgroundColor: '#fff',
                    border: '1px solid #e0e0e0',
                    borderRadius: 2,
                    p: 4,
                    mb: 4,
                    boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
                }}>
                    <Box mb={3}>
                        <Typography variant="h6" fontWeight="bold" sx={{ fontFamily: 'Signika, sans-serif' }}>
                            Dokumen yang Dilampirkan <span style={{ color: 'red' }}>*</span>
                        </Typography>
                        {errors.mitraAttachmentDocument && (
                            <Typography variant="body2" style={{ color: '#FF0000', fontFamily: 'Signika, sans-serif', mt: 1 }}>
                                {errors.mitraAttachmentDocument}
                            </Typography>
                        )}
                    </Box>
                    <Grid container spacing={3}>
                        {/* Salinan Akta *
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={mitraAttachmentChecked.salinan_akta}
                                        onChange={(e) => setMitraAttachmentChecked({ ...mitraAttachmentChecked, salinan_akta: e.target.checked })}
                                        color="primary"
                                    />
                                }
                                label="Salinan akta pendirian perusahaan/badan usaha"
                                sx={{ '& .MuiFormControlLabel-label': { fontFamily: 'Signika, sans-serif' } }}
                            />
                            {mitraAttachmentChecked.salinan_akta && (
                                <Box ml={4} mt={1}>
                                    <input
                                        id="upload-salinan-akta"
                                        type="file"
                                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                                        multiple
                                        style={{ display: 'none' }}
                                        onChange={(e) => {
                                            if (e.target.files.length > 0) {
                                                handleAttachmentUpload('salinan_akta', Array.from(e.target.files));
                                            }
                                        }}
                                    />
                                    <Button
                                        variant="outlined"
                                        onClick={() => document.getElementById('upload-salinan-akta').click()}
                                        disabled={mitraAttachmentUploading.salinan_akta}
                                        sx={{ fontFamily: 'Signika, sans-serif' }}
                                        startIcon={mitraAttachmentUploading.salinan_akta ? <CircularProgress size={20} /> : null}
                                    >
                                        {mitraAttachmentUploading.salinan_akta ? 'Mengunggah...' : 'Unggah File'}
                                    </Button>
                                    {mitraAttachmentDocument.salinan_akta.length > 0 && (
                                        <Box mt={1}>
                                            {mitraAttachmentDocument.salinan_akta.map((file, index) => (
                                                <Box key={index} display="flex" alignItems="center" gap={1} mb={1}>
                                                    <Typography variant="body2" sx={{ fontFamily: 'Signika, sans-serif' }}>{file.name}</Typography>
                                                    <IconButton size="small" onClick={() => handleAttachmentRemove('salinan_akta', index)}>
                                                        <CloseIcon fontSize="small" />
                                                    </IconButton>
                                                </Box>
                                            ))}
                                        </Box>
                                    )}
                                </Box>
                            )}
                        </Grid>

                        {/* Salinan NIB/SIUP/TDP *
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={mitraAttachmentChecked.salinan_nib_siup_tpd}
                                        onChange={(e) => setMitraAttachmentChecked({ ...mitraAttachmentChecked, salinan_nib_siup_tpd: e.target.checked })}
                                        color="primary"
                                    />
                                }
                                label="Salinan NIB/SIUP/TDP"
                                sx={{ '& .MuiFormControlLabel-label': { fontFamily: 'Signika, sans-serif' } }}
                            />
                            {mitraAttachmentChecked.salinan_nib_siup_tpd && (
                                <Box ml={4} mt={1}>
                                    <input
                                        id="upload-salinan-nib"
                                        type="file"
                                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                                        multiple
                                        style={{ display: 'none' }}
                                        onChange={(e) => {
                                            if (e.target.files.length > 0) {
                                                handleAttachmentUpload('salinan_nib_siup_tpd', Array.from(e.target.files));
                                            }
                                        }}
                                    />
                                    <Button
                                        variant="outlined"
                                        onClick={() => document.getElementById('upload-salinan-nib').click()}
                                        disabled={mitraAttachmentUploading.salinan_nib_siup_tpd}
                                        sx={{ fontFamily: 'Signika, sans-serif' }}
                                        startIcon={mitraAttachmentUploading.salinan_nib_siup_tpd ? <CircularProgress size={20} /> : null}
                                    >
                                        {mitraAttachmentUploading.salinan_nib_siup_tpd ? 'Mengunggah...' : 'Unggah File'}
                                    </Button>
                                    {mitraAttachmentDocument.salinan_nib_siup_tpd.length > 0 && (
                                        <Box mt={1}>
                                            {mitraAttachmentDocument.salinan_nib_siup_tpd.map((file, index) => (
                                                <Box key={index} display="flex" alignItems="center" gap={1} mb={1}>
                                                    <Typography variant="body2" sx={{ fontFamily: 'Signika, sans-serif' }}>{file.name}</Typography>
                                                    <IconButton size="small" onClick={() => handleAttachmentRemove('salinan_nib_siup_tpd', index)}>
                                                        <CloseIcon fontSize="small" />
                                                    </IconButton>
                                                </Box>
                                            ))}
                                        </Box>
                                    )}
                                </Box>
                            )}
                        </Grid>

                        {/* Profil Perusahaan *
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={mitraAttachmentChecked.profile}
                                        onChange={(e) => setMitraAttachmentChecked({ ...mitraAttachmentChecked, profile: e.target.checked })}
                                        color="primary"
                                    />
                                }
                                label="Profil perusahaan (brosur/portofolio singkat)"
                                sx={{ '& .MuiFormControlLabel-label': { fontFamily: 'Signika, sans-serif' } }}
                            />
                            {mitraAttachmentChecked.profile && (
                                <Box ml={4} mt={1}>
                                    <input
                                        id="upload-profile"
                                        type="file"
                                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                                        multiple
                                        style={{ display: 'none' }}
                                        onChange={(e) => {
                                            if (e.target.files.length > 0) {
                                                handleAttachmentUpload('profile', Array.from(e.target.files));
                                            }
                                        }}
                                    />
                                    <Button
                                        variant="outlined"
                                        onClick={() => document.getElementById('upload-profile').click()}
                                        disabled={mitraAttachmentUploading.profile}
                                        sx={{ fontFamily: 'Signika, sans-serif' }}
                                        startIcon={mitraAttachmentUploading.profile ? <CircularProgress size={20} /> : null}
                                    >
                                        {mitraAttachmentUploading.profile ? 'Mengunggah...' : 'Unggah File'}
                                    </Button>
                                    {mitraAttachmentDocument.profile.length > 0 && (
                                        <Box mt={1}>
                                            {mitraAttachmentDocument.profile.map((file, index) => (
                                                <Box key={index} display="flex" alignItems="center" gap={1} mb={1}>
                                                    <Typography variant="body2" sx={{ fontFamily: 'Signika, sans-serif' }}>{file.name}</Typography>
                                                    <IconButton size="small" onClick={() => handleAttachmentRemove('profile', index)}>
                                                        <CloseIcon fontSize="small" />
                                                    </IconButton>
                                                </Box>
                                            ))}
                                        </Box>
                                    )}
                                </Box>
                            )}
                        </Grid>

                        {/* Daftar Penerjemah *
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={mitraAttachmentChecked.profession}
                                        onChange={(e) => setMitraAttachmentChecked({ ...mitraAttachmentChecked, profession: e.target.checked })}
                                        color="primary"
                                    />
                                }
                                label="Daftar penerjemah/juru bahasa mitra/tetap"
                                sx={{ '& .MuiFormControlLabel-label': { fontFamily: 'Signika, sans-serif' } }}
                            />
                            {mitraAttachmentChecked.profession && (
                                <Box ml={4} mt={1}>
                                    <input
                                        id="upload-profession"
                                        type="file"
                                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                                        multiple
                                        style={{ display: 'none' }}
                                        onChange={(e) => {
                                            if (e.target.files.length > 0) {
                                                handleAttachmentUpload('profession', Array.from(e.target.files));
                                            }
                                        }}
                                    />
                                    <Button
                                        variant="outlined"
                                        onClick={() => document.getElementById('upload-profession').click()}
                                        disabled={mitraAttachmentUploading.profession}
                                        sx={{ fontFamily: 'Signika, sans-serif' }}
                                        startIcon={mitraAttachmentUploading.profession ? <CircularProgress size={20} /> : null}
                                    >
                                        {mitraAttachmentUploading.profession ? 'Mengunggah...' : 'Unggah File'}
                                    </Button>
                                    {mitraAttachmentDocument.profession.length > 0 && (
                                        <Box mt={1}>
                                            {mitraAttachmentDocument.profession.map((file, index) => (
                                                <Box key={index} display="flex" alignItems="center" gap={1} mb={1}>
                                                    <Typography variant="body2" sx={{ fontFamily: 'Signika, sans-serif' }}>{file.name}</Typography>
                                                    <IconButton size="small" onClick={() => handleAttachmentRemove('profession', index)}>
                                                        <CloseIcon fontSize="small" />
                                                    </IconButton>
                                                </Box>
                                            ))}
                                        </Box>
                                    )}
                                </Box>
                            )}
                        </Grid>
                    </Grid>
                </Box> */}

                {/* Simpan Button */}
                <Box mt={4} mb={3}>
                    <Button
                        variant="contained"
                        fullWidth
                        size="large"
                        style={{
                            py: 4,
                            borderRadius: 2,
                            fontSize: "1.125rem",
                            color: "#FFFFFF",
                            fontWeight: "bold",
                            fontFamily: 'Signika, sans-serif',
                            backgroundColor: '#0000FF',
                            '&:hover': {
                                backgroundColor: '#0000FF'
                            }
                        }}
                        onClick={handleSubmit}
                    >
                        Simpan
                    </Button>
                </Box>
            </Container>
        </>

    );
}